import { Expose, Type, plainToClassFromExist } from 'class-transformer';

import { SnStreamSources } from './stream-sources';

export class SnStreamSourceList {
  @Expose()
  @Type(() => SnStreamSources)
  public cloud: SnStreamSources;

  @Expose()
  @Type(() => SnStreamSources)
  public local: SnStreamSources;

  constructor(data: any = {}) {
    plainToClassFromExist(this, data, { strategy: 'excludeAll' });
  }
}
